import React, { useEffect, useRef } from 'react'
import { Container, ModalArea } from './styles'

interface Props {
  'data-qa'?: string
  onClose?: Function
  children: any
}

const Modal: React.FC<Props> = (props: Props): JSX.Element => {
  const ref = useRef(null)

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target) && props?.onClose) {
      props.onClose()
    }
  }

  return (
    <ModalArea data-qa={props['data-qa'] || 'modal'}>
      <Container ref={ref}>{props.children}</Container>
    </ModalArea>
  )
}

export default Modal
